import {
  RadioGroupField,
  RadioGroupItem
} from '@ps-design-system/components/RadioGroup';
import { Text } from '@ps-design-system/components/Text';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import { useCheckoutContext } from '../../CheckoutContextProvider';
import { getCurrencyFromListing } from '../../checkout-utils';

export const PaymentOptionField = ({ disabled }) => {
  const { quote, listing } = useCheckoutContext();

  const currency = getCurrencyFromListing(listing);

  const guestCalculations = quote?.masterContract?.calculations?.guest || {};
  const splitPaymentBreakdown = guestCalculations.split_payment || {};

  const payFullTotal = quote?.masterContract?.split_payment_checkout
    ? guestCalculations.payment - splitPaymentBreakdown.fee
    : guestCalculations.payment;

  return (
    <RadioGroupField
      name="selectedPaymentOption"
      testId="payment-option-field"
      disabled={disabled}
      variant="box"
    >
      <RadioGroupItem
        value="pay_full"
        id="pay_full"
        label={
          <FormattedMessage
            id="booking_details_form.pay_full"
            defaultMessage="Pay {payFullTotal} now"
            values={{
              payFullTotal: (
                <FormattedNumber
                  value={payFullTotal}
                  style="currency"
                  currency={currency}
                />
              )
            }}
          />
        }
      />
      <RadioGroupItem
        value="pay_partial"
        id="pay_partial"
        label={
          <FormattedMessage
            id="booking_details_form.pay_partial"
            defaultMessage="Pay part now, part later"
          />
        }
        note={
          <Text testId="pay_partial_note" style={{ textTransform: 'none' }}>
            <FormattedMessage
              id="booking_details_form.pay_partial_note"
              defaultMessage="Pay {firstPaymentAmount} today (includes {feeAmount} fee), then {secondPayment} on {splitPaymentChargeDate}."
              values={{
                firstPaymentAmount: (
                  <FormattedNumber
                    value={splitPaymentBreakdown.parts?.[0]}
                    style="currency"
                    currency={currency}
                  />
                ),
                secondPayment: (
                  <FormattedNumber
                    value={splitPaymentBreakdown.parts?.[1]}
                    style="currency"
                    currency={currency}
                  />
                ),
                feeAmount: (
                  <FormattedNumber
                    value={splitPaymentBreakdown.fee}
                    style="currency"
                    currency={currency}
                  />
                ),
                splitPaymentChargeDate: (
                  <FormattedDate
                    value={quote?.masterContract?.split_payment_charge_date}
                    year="numeric"
                    month="short"
                    day="numeric"
                  />
                )
              }}
            />
          </Text>
        }
      />
    </RadioGroupField>
  );
};

PaymentOptionField.displayName = 'PaymentOptionField';
PaymentOptionField.propTypes = {
  disabled: PropTypes.bool
};
